import { useAdminAccessRequests } from '@/lib/hooks/useAdmin';
import { useMe } from '@/lib/hooks/useBootstrap';

export function AdminAccessRequestsPage() {
  const { data: me } = useMe(true);
  const isAdmin = me?.user.is_admin === true;
  const { data } = useAdminAccessRequests();

  if (me && !isAdmin) {
    return (
      <div className="mx-auto max-w-2xl px-8 py-16 text-center text-sm text-slate-500">
        This area is restricted to Momentum AI staff.
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-5xl px-8 py-10">
      <header className="mb-6">
        <h1 className="text-3xl font-semibold tracking-tight">_admin · access requests</h1>
        <p className="mt-1 text-sm text-slate-500">
          Leads from the /signup request-access form.{' '}
          {data ? `${data.total} total` : 'loading…'}
        </p>
      </header>

      <div className="overflow-hidden rounded-xl border border-slate-200 dark:border-slate-800">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500 dark:bg-slate-900">
            <tr>
              <th className="px-3 py-2 font-medium">Name</th>
              <th className="px-3 py-2 font-medium">Email</th>
              <th className="px-3 py-2 font-medium">Phone</th>
              <th className="px-3 py-2 font-medium">Requested</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
            {data?.items.map((r) => (
              <tr key={r.id}>
                <td className="px-3 py-2 font-medium">{r.full_name}</td>
                <td className="px-3 py-2">
                  <a href={`mailto:${r.email}`} className="hover:underline">
                    {r.email}
                  </a>
                </td>
                <td className="px-3 py-2">{r.phone ?? <span className="text-slate-400">—</span>}</td>
                <td className="px-3 py-2 text-xs text-slate-500">
                  {new Date(r.created_at).toLocaleString()}
                </td>
              </tr>
            ))}
            {data && data.items.length === 0 && (
              <tr>
                <td colSpan={4} className="px-3 py-8 text-center text-sm text-slate-500">
                  No access requests yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
